export const monthsIndexes = {
    Jan: 1,
    Fev: 2,
    Mar: 3,
    Abr: 4,
    Mai: 5,
    Jun: 6,
    Jul: 7,
    Ago: 8,
    Set: 9,
    Out: 10,
    Nov: 11,
    Dez: 12
};

export const monthsToIndexesWith0 = {
    Jan: '01',
    Fev: '02',
    Mar: '03',
    Abr: '04',
    Mai: '05',
    Jun: '06',
    Jul: '07',
    Ago: '08',
    Set: '09',
    Out: '10',
    Nov: '11',
    Dez: '12'
};


export const monthsIndexesWith0 = {
    '01': 'Janeiro',
    '02': 'Fevereiro',
    '03': 'Março',
    '04': 'Abril',
    '05': 'Maio',
    '06': 'Junho',
    '07': 'Julho',
    '08': 'Agosto',
    '09': 'Setembro',
    '10': 'Outubro',
    '11': 'Novembro',
    '12': 'Dezembro'
};

export const monthsIndexesWithou0 = {
    '1': 'Jan',
    '2': 'Fev',
    '3': 'Mar',
    '4': 'Abr',
    '5': 'Mai',
    '6': 'Jun',
    '7': 'Jul',
    '8': 'Ago',
    '9': 'Set',
    '10': 'Out',
    '11': 'Nov',
    '12': 'Dez'
};

export function getMonthsByYear(ano, smallName = false) {
    if (!ano) {
        return [];
    }

    const monthsComplete = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
    ];

    const monsthsReduced = [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez'
    ];

    const anoAtual = new Date().getFullYear();
    const mesAtual = new Date().getMonth();

    const months = smallName ? monsthsReduced : monthsComplete;

    if (ano == anoAtual) {
        return months.slice(0, mesAtual + 1);
    } else {
        return months;
    }
}

export function getSelectedYearMonths(filters) {
    return getMonthsByYear(filters.ano?.value, true).filter((month) => {
        if (filters.competencia.label !== 'Todos') {
            return filters.competencia.label
                .toUpperCase()
                .startsWith(month.toUpperCase());
        }

        return true;
    });
}

export function getSelectedYearMonthsByYear(year) {
    return getMonthsByYear(year, true);
}
